// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"793":"c80b78652cdc40b019b35351c6942de3","929":"4db150d8b8ef8df95a0b20bd24174606"}[chunkId] + ".js";
};